<template>
  <b-col>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-tabs class="w-100" @input="cambioTabtx($event)" content-class="mt-3" justified>
        <b-tab title="Modúlos" active>
          <b-col>
            <b-row v-if="indexTabTx === 0">
              <b-col cols="4">
                <b-card-group deck>
                  <b-card
                      header="Módulos"
                      header-tag="header"
                  >
                    <div align="center" v-if="loaderModulos">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <b-list-group v-else flush>
                      <b-list-group-item v-for="(item, index) in modulos" :key="item.nombre+index">
                        <b-row>
                          <b-col class="text-left" cols="10">
                            <strong>{{ item.nombre }}</strong>
                          </b-col>
                          <b-col cols="2">
                            <b-button v-if="!item.seleccionado" @click="selecionarModulo(item)"
                                      size="sm"
                                      variant="outline-primary"><em class="fa fa-plus-circle"></em>
                            </b-button>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card>
                </b-card-group>
              </b-col>
              <b-col>
                <div align="center" v-if="loaderModulosSel">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
                <div v-else class="accordion" role="tablist">

                  <b-card no-body class="mb-1" v-for="(mod, index) in selecionados"
                          :key="mod.nombre+'selec'+index">
                    <b-card-header header-tag="header" class="p-0" role="tab">
                      <b-button-group class="w-100">
                        <b-button block v-b-toggle="'accordion-' + index" variant="info">{{ mod.nombre }}</b-button>
                        <b-button v-b-tooltip.hover title="Eliminar Modulo" variant="danger"
                                  @click="eliminarModulo(mod)"><em class="fa fa-trash"></em></b-button>
                      </b-button-group>

                    </b-card-header>
                    <b-row>
                      <b-col class="text-right">
                      </b-col>
                    </b-row>

                    <b-collapse :id="'accordion-'+index" visible accordion="my-accordion" role="tabpanel">
                      <b-card-body style="max-height: 30em; overflow: auto">
                        <b-list-group-item v-for="(tx, index) in mod.tratamientos"
                                           :key="tx.nombre+'txs'+index">
                          <b-row>
                            <b-col class="text-left" cols="10">
                              <strong v-if="tx.idTipoDescuentoPlan === 1">
                                {{ tx.descuento + '%' }}
                                {{ tx.nombre }}
                                <strong style="font-size: 13px">
                                  {{
                                    tx.descuentoEspecial != null && tx.descuentoEspecial > 0 ? " Descuento especial: " + tx.descuentoEspecial + '%' + " (" + (tx.numeroVeces != null ? tx.numeroVeces : 1) + " al año)" : ""
                                  }}
                                </strong>
                              </strong>
                              <strong v-else-if="tx.idTipoDescuentoPlan === 2">
                                {{ '$' + tx.descuento }} (Monto descuento)
                                {{ tx.nombre }}
                                <strong style="font-size: 13px">{{
                                    tx.descuentoEspecial != null && tx.descuentoEspecial > 0 ? " Monto descuento especial: " + '$' + tx.descuentoEspecial + " (" + (tx.numeroVeces != null ? tx.numeroVeces : 1) + " al año)" : ""
                                  }}
                                </strong>
                              </strong>
                              <strong v-else>
                                {{ '$' + tx.descuento }} (Co-pago fijo)
                                {{ tx.nombre }}
                                <strong style="font-size: 13px">{{
                                    tx.descuentoEspecial != null && tx.descuentoEspecial > 0 ? " Descuento co-pago especial: " + '$' + tx.descuentoEspecial + " (" + (tx.numeroVeces != null ? tx.numeroVeces : 1) + " al año)" : ""
                                  }}
                                </strong>
                              </strong>
                            </b-col>
                            <b-col cols="2">
                              <b-button @click="editarTratamiento(tx)" size="sm"
                                        variant="outline-primary"><em class="fa fa-pencil"></em>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-list-group-item>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-col>

            </b-row>
          </b-col>
        </b-tab>
        <b-tab title="Grupos">
          <b-col>
            <b-row v-if="indexTabTx === 1">
              <b-col cols="4">
                <b-card-group deck>
                  <b-card
                      header="Grupos"
                      header-tag="header"
                  >
                    <b-card-text>
                      <b-button block variant="outline-success" @click="abrirModalNuevoGrupo">Crear grupo
                      </b-button>
                    </b-card-text>
                    <div align="center" v-if="loaderGrupos">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <b-list-group v-else style="max-height: 30em; overflow: auto" flush>
                      <b-list-group-item v-for="(item, index) in grupos" :key="item.nombre+index">
                        <b-row>
                          <b-col class="text-left" cols="10">
                            <strong>{{ item.nombre }}</strong>
                          </b-col>
                          <b-col cols="2">
                            <b-button-group>
                              <b-button
                                  @click="detalleGrupo(item)"
                                  title="Detalle del grupo"
                                  size="sm"
                                  variant="outline-secondary"><em class="fa fa-info"></em>
                              </b-button>
                              <b-button v-if="!item.seleccionado" @click="selecionarGrupo(item)"
                                        title="Agregar Grupo"
                                        size="sm"
                                        variant="outline-primary"><em class="fa fa-plus-circle"></em>
                              </b-button>
                            </b-button-group>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card>
                </b-card-group>
              </b-col>
              <b-col>
                <b-card
                    header="Grupos del plan"
                    header-tag="header"
                >
                  <div align="center" v-if="loaderGruposSel">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </div>
                  <div v-else>
                    <b-list-group-item style="max-height: 30em; overflow: auto"
                                       v-for="(grupo, index) in gruposSeleccionados"
                                       :key="grupo.nombre+'txsGrupo'+index">
                      <b-row>
                        <b-col class="text-left" cols="10">
                          <strong v-if="grupo.idTipoDescuentoPlan === 1">
                            {{ grupo.descuento + '% ' }}
                          </strong>
                          <strong v-else-if="grupo.idTipoDescuentoPlan === 2">
                            {{ '$' + grupo.descuento }} (Monto descuento)
                          </strong>
                          <strong v-else>
                            {{ '$' + grupo.descuento }} (Co-pago fijo)
                          </strong>
                          {{ grupo.nombre }}
                          <strong v-if="grupo.idTipoDescuentoPlan === 1" style="font-size: 13px">
                            {{
                              grupo.descuentoEspecial != null && grupo.descuentoEspecial > 0 ? " Descuento especial: " + grupo.descuentoEspecial + '%' + " (" + (grupo.numeroVeces != null ? grupo.numeroVeces : 1) + " al año)" : ""
                            }}

                            <ul>
                              <li v-for="(item, index) in grupo.tratamientos" :key="item.descripcion+index">
                                {{ item.descripcion }}
                              </li>
                            </ul>

                          </strong>
                          <strong v-else-if="grupo.idTipoDescuentoPlan === 2" style="font-size: 13px">
                            {{
                              grupo.descuentoEspecial != null && grupo.descuentoEspecial > 0 ? " Monto descuento especial: " + '$' + grupo.descuentoEspecial + " (" + (grupo.numeroVeces != null ? grupo.numeroVeces : 1) + " al año)" : ""
                            }}

                            <ul>
                              <li v-for="(item, index) in grupo.tratamientos" :key="item.descripcion+index">
                                {{ item.descripcion }}
                              </li>
                            </ul>

                          </strong>
                          <strong v-else style="font-size: 13px">
                            {{
                              grupo.descuentoEspecial != null && grupo.descuentoEspecial > 0 ? " Descuento co-pago especial: " + '$' + grupo.descuentoEspecial + " (" + (grupo.numeroVeces != null ? grupo.numeroVeces : 1) + " al año)" : ""
                            }}

                            <ul>
                              <li v-for="(item, index) in grupo.tratamientos" :key="item.descripcion+index">
                                {{ item.descripcion }}
                              </li>
                            </ul>

                          </strong>
                        </b-col>
                        <b-col>
                          <b-button size="sm" variant="outline-danger" @click="eliminarGrupo(grupo)"><em
                              class="fa fa-trash"></em></b-button>
                          <b-button size="sm" variant="outline-warning" @click="editarGrupo(grupo)"><em
                              class="fa fa-pencil"></em></b-button>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-tab>
      </b-tabs>
    </b-row>


    <!--    modales    <-->
    <b-modal
        v-model="modalConfiguracion"
        static
        lazy
        title="Configuración"
        size="md"
        centered
    >
      <b-row>
        <b-col cols="12">
          <b-form-group label="Tipo de descuento: " label-for="idTipoDescuentoPlan">
            <b-form-select
                :options="tiposDescuentoPlan"
                text-field="descripcion"
                value-field="idTipoDescuentoPlan"
                v-model="$v.configuracionModulo.idTipoDescuentoPlan.$model"
                id="idTipoDescuentoPlan"
                :state="validateState('idTipoDescuentoPlan')"
                required
            ></b-form-select>
          </b-form-group>

        </b-col>


        <b-col cols="12">
          <b-form-group :label="configuracionModulo.idTipoDescuentoPlan !== 3 ? configuracionModulo.idTipoDescuentoPlan === 1 ? 'Descuentos: ' : 'Monto descuento: ' : 'Precio fijo: '" label-for="decuentotratamiento ">
            <b-form-input
                size="sm"
                id="decuentotratamiento"
                v-model.lazy="$v.configuracionModulo.descuento.$model"
                :state="validateState('descuento')"
                type="number"
                required
                min="0"
                :max="configuracionModulo.idTipoDescuentoPlan === 1 ? 100 : null "
            ></b-form-input>
          </b-form-group>

        </b-col>

        <b-col cols="12">

          <b-form-group :label="configuracionModulo.idTipoDescuentoPlan !== 3 ? configuracionModulo.idTipoDescuentoPlan === 1 ? 'Descuento Especial: ' : 'Monto descuento especial: ' : 'Precio fijo especial: '"
                        label-for="descuentoespecialtratamiento">
            <b-form-input
                size="sm"
                id="descuentoespecialtratamiento"
                v-model.lazy="$v.configuracionModulo.descuentoEspecial.$model"
                :state="validateState('descuentoEspecial')"
                type="number"
                min="0"
                :max="configuracionModulo.idTipoDescuentoPlan === 1 ? 100 : null "
            ></b-form-input>
          </b-form-group>

        </b-col>

        <b-col cols="12">

          <b-form-group label="Número de veces al año: " label-for="numeroveces">
            <b-form-input
                size="sm"
                id="numeroveces"
                v-model.lazy="$v.configuracionModulo.numeroVeces.$model"
                :state="validateState('numeroVeces')"
                type="number"
            ></b-form-input>
          </b-form-group>

        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="agregar()">
          <span v-if="!loaderAcciones">Agregar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>

    </b-modal>

    <!--   modal nuevo grupo     -->
    <b-modal
        v-model="modalGrupo"
        title="Crear nuevo grupo"
        size="lg"
        no-close-on-backdrop
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label>Nombre
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="nombreGrupo" name="nombreMenu" placeholder="Nombre del perfil"
                                v-model="nuevoGrupo.nombre"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="trtsg">Tratamientos</label>
                <validacion/>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select id="trtsg" name="trtsg"
                            placeholder="Tratamientos"
                            multiple
                            v-model="nuevoGrupo.tratamientos"
                            label="nombre"
                            :options="tratamientos"
                            style="width: 95%"
                  ></v-select>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardarGrupo()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="modalDetalleGrupo"
        title="Tratamientos del grupo"
        centered
        no-close-on-backdrop
    >
      <ul v-if="detalle != null">
        <li v-for="(item, index) in detalle" :key="item.descripcion+index">{{ item.descripcion }}</li>
      </ul>
    </b-modal>

    <b-modal
        v-model="modalSeleccionarGrupoTx"
        title="Seleccionar grupo para los tratamientos"
        centered
        no-close-on-backdrop
    >
      <b-table
          id="Pendientes"
          thead-tr-class="columnas"
          :items="listaExiste"
          :fields="columnasSelect"
          responsive="true"
          class="parrafos"
          fixed>
        <template v-slot:cell(Grupo)="row">
          <v-select
              label="nombre"
              v-model="row.item.grupo"
              :options="row.item.grupos"
          ></v-select>
        </template>
        <div slot="modal-footer">
          <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardarTratameintosExistentes()">
            <span v-if="!loaderAcciones">Guardar</span>
            <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
          </b-button>
          <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
        </div>
      </b-table>
    </b-modal>

  </b-col>
</template>

<script>
import {numeric, required} from "vuelidate/lib/validators";

const decimal = (value) => {
  return !isNaN(value) && /^-?\d+(\.\d+)?$/.test(value)
}

export default {
  name: "TratamientosPlan",
  props: {
    idPlan: Number,
    tiposDescuentoPlan: Array,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      indexTabTx: 0,
      modulos: [],
      fields: [
        {key: "nombre", label: "Módulo", sortable: true},
        "Seleccionado",
        "Porcentaje",
      ],
      columnasSelect: [
        {key: "descripcion", label: "Descripción"},
        "Grupo",
      ],
      modalConfiguracion: false,
      loaderAcciones: false,
      moduloSeleccioonado: null,
      configuracionModulo: {
        idTipoDescuentoPlan: null,
        descuento: null,
        descuentoEspecial: null,
        numeroVeces: null,
        descuentoDefault: null
      },
      selecionados: [],
      tratamientoSelecionado: null,

      grupos: [],
      modalGrupo: false,
      nuevoGrupo: {
        nombre: null,
        tratamientos: []
      },
      tratamientos: [],
      grupoSeleccionado: null,
      tratamientosGrupo: [],
      gruposSeleccionados: [],
      listaExiste: [],
      tratamientosgrupos: [],
      loaderModulos: false,
      loaderModulosSel: false,
      loaderGrupos: false,
      loaderGruposSel: false,
      banderaMod: false,
      modalDetalleGrupo: false,
      modalSeleccionarGrupoTx: false,
      detalle: null
    }
  },
  validations() {
    if (this.configuracionModulo.idTipoDescuentoPlan === 3){
      return {
        configuracionModulo: {
          idTipoDescuentoPlan: {required},
          descuento: {required, numeric},
          descuentoEspecial: {numeric},
          numeroVeces: {numeric},
        }
      }
    } else {
      return {
        configuracionModulo: {
          idTipoDescuentoPlan: {required},
          descuento: {required, decimal},
          descuentoEspecial: {numeric},
          numeroVeces: {numeric}
        }
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerModulos();
    this.obtenerTratamientosPorPlan();
    this.obtenerGrupossPorPlan();
    this.obtenerGrupos();
    this.obtenerTratamientos();
  },
  methods: {
    obtenerModulos() {
      this.loaderModulos = true
      this.modulos = [];
      const obj = {
        id: null,
        palabraClave: null,
        registroActivo: true
      };
      this.$http.post(this.$api + 'modulo/obtener', obj).then(respuesta => {
            if (respuesta.data.data) {

              respuesta.data.data.map(it => {
                it.seleccionado = false;
                it.porcentaje = null;
              });

              this.modulos = respuesta.data.data.filter(t => t.registroActivo)
              this.validarSeleccionados();
            }
          }
      ).finally(() => {
        this.loaderModulos = false
      })
    },
    obtenerTratamientosPorPlan() {
      this.loaderModulosSel = true
      if (this.idPlan !== undefined) {
        const parametros = {idPlan: this.idPlan}
        this.$http.post(this.$api + 'planConvenio/obtenerTratamientosplan', parametros).then(
            respuesta => {
              if (respuesta.data.data) {
                this.selecionados = respuesta.data.data;
                this.validarSeleccionados();
              }
            }
        ).finally(() => {
          this.loaderModulosSel = false
        })
      }
    },
    obtenerGrupossPorPlan() {
      if (this.idPlan !== undefined) {
        this.loaderGruposSel = true
        const parametros = {idPlan: this.idPlan}
        this.$http.post(this.$api + 'planConvenio/obtenerGruposplan', parametros).then(
            respuesta => {
              if (respuesta.data.data) {
                this.gruposSeleccionados = respuesta.data.data;
                this.validarSeleccionadosGrupo();
              }
            }
        ).finally(() => {
          this.loaderGruposSel = false
        })
      }
    },
    obtenerGrupos() {
      this.loaderGrupos = true
      this.$http.get(this.$api + 'catalogos/listaTratamientosGrupos').then(
          respuesta => {
            if (respuesta.data.data) {
              this.grupos = respuesta.data.data;
              this.validarSeleccionadosGrupo();
            }

          }
      ).finally(() => {
        this.loaderGrupos = false
      })
    },
    obtenerTratamientos() {
      this.$http.get(this.$api + 'planConvenio/obtener/tratamientos/categoria').then(
          respuesta => {
            if (respuesta.data.data) {
              this.tratamientos = respuesta.data.data;
            }

          }
      )
    },

    selecionarModulo(item) {
      this.configuracionModulo = {
        descuento: null,
        descuentoEspecial: null,
        numeroVeces: null,
        descuentoDefault: null,
        idTipoDescuentoPlan: null
      };
      this.moduloSeleccioonado = item;
      this.modalConfiguracion = true;
    },
    selecionarGrupo(item) {
      this.configuracionModulo = {
        descuento: null,
        descuentoEspecial: null,
        numeroVeces: null,
        descuentoDefault: null,
        idTipoDescuentoPlan: null
      };
      this.grupoSeleccionado = item;

      const datos = this.validadTratamientosGrupo();

      if (datos) {
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Ya existen tratamientos de este grupo en uno ya seleccionado"
        });
        return false;
      }

      this.modalConfiguracion = true;
    },
    agregar() {
      this.$v.configuracionModulo.$touch();
      if (this.$v.configuracionModulo.$anyError) {
        return  false;
      }

      if(this.configuracionModulo.idTipoDescuentoPlan === 1 && (this.configuracionModulo.descuento > 100 || this.configuracionModulo.descuentoEspecial > 100)){
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Tienes un descuento mayor al 100%, favor de corregirlo"
        });
        return false;
      }

      if(this.configuracionModulo.descuento < 0 || this.configuracionModulo.descuentoEspecial < 0){
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Tienes un descuento menor a 0, favor de corregirlo"
        });
        return false;
      }

      if (this.moduloSeleccioonado != null) {
        this.modulos.map(it => {
          if (it.idModulo === this.moduloSeleccioonado.idModulo) {
            it.seleccionado = true;
          }
        })

        this.moduloSeleccioonado.tratamientos.map(trat => {
          trat.idTipoDescuentoPlan = this.configuracionModulo.idTipoDescuentoPlan;
          trat.descuento = this.configuracionModulo.descuento;
          trat.descuentoEspecial = this.configuracionModulo.descuentoEspecial;
          trat.numeroVeces = this.configuracionModulo.numeroVeces;
          trat.descuentoDefault = this.configuracionModulo.descuentoDefault;
          trat.idModulo = this.moduloSeleccioonado.idModulo
        })


        this.guardar()

      } else if (this.tratamientoSelecionado !== null) {
        this.tratamientoSelecionado.idTipoDescuentoPlan = this.configuracionModulo.idTipoDescuentoPlan;
        this.tratamientoSelecionado.descuento = this.configuracionModulo.descuento;
        this.tratamientoSelecionado.descuentoEspecial = this.configuracionModulo.descuentoEspecial;
        this.tratamientoSelecionado.numeroVeces = this.configuracionModulo.numeroVeces;
        this.actualizarTratameinto(this.tratamientoSelecionado)

      } else if (this.grupoSeleccionado !== null) {

        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Al  agregar el grupo se borraran los tratamientos de agregados desde los modulos ¿Desea agregar el grupo?",
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          showCancelButton: true,
          showConfirmButton: true,
        }).then(respuesta => {
          if (respuesta.value) {
            this.grupos.map(it => {

              if (it.idTratamientoGrupo === this.grupoSeleccionado.idTratamientoGrupo) {
                it.seleccionado = true;
              }
            })
            this.grupoSeleccionado.idTipoDescuentoPlan = this.configuracionModulo.idTipoDescuentoPlan;
            this.grupoSeleccionado.descuento = this.configuracionModulo.descuento;
            this.grupoSeleccionado.descuentoEspecial = this.configuracionModulo.descuentoEspecial;
            this.grupoSeleccionado.numeroVeces = this.configuracionModulo.numeroVeces;
            this.grupoSeleccionado.descuentoDefault = this.configuracionModulo.descuentoDefault;

            this.guardarGrupoPlan();
          }
        })

      }
    },
    cerrarModal() {
      this.modalConfiguracion = false
      this.modalDetalleGrupo = false;
      this.modalGrupo = false;
    },
    validadTratamientosGrupo() {
      this.listaExiste = [];
      let grupos = [];

      this.grupoSeleccionado.tratamientos.map(t => {

        grupos = this.gruposSeleccionados.filter(g => {
          return g.tratamientos.filter(tx => tx.idTratamiento === t.idTratamiento).length > 0
        })

        if (grupos.length > 0) {
          grupos.push(this.grupoSeleccionado);
          this.listaExiste.push({
            idTratamiento: t.idTratamiento,
            descripcion: t.descripcion,
            grupos: grupos,
            grupo: this.grupoSeleccionado
          })
        }

      })

      if (this.listaExiste.length > 0) {
        return true;
      } else {
        return false;
      }


    },
    editarTratamiento(item) {
      this.configuracionModulo = {
        idTipoDescuentoPlan: item.idTipoDescuentoPlan,
        descuento: item.descuento,
        descuentoEspecial: item.descuentoEspecial,
        numeroVeces: item.numeroVeces,
        descuentoDefault: item.descuentoDefault
      };
      this.tratamientoSelecionado = item;
      this.modalConfiguracion = true;
    },
    validarSeleccionados() {
      this.modulos.forEach(it => {
        this.selecionados.forEach(t => {
          if (t.idModulo === it.idModulo) {
            it.seleccionado = true;
          }
        })
      })
    },
    validarSeleccionadosGrupo() {
      this.grupos.forEach(it => {
        this.gruposSeleccionados.forEach(t => {
          if (t.idTratamientoGrupo === it.idTratamientoGrupo) {
            it.seleccionado = true;
          }
        })
      })
    },
    guardarGrupo() {
      this.loaderAcciones = true;
      this.$http.post(this.$api + 'planConvenio/guardar/grupo?idPlan=' + this.idPlan, this.nuevoGrupo).then(respuesta => {
        if (respuesta.data.data) {
          this.obtenerGrupos();
          this.modalGrupo = false;
        }

      }).finally(() => {
        this.loaderAcciones = false
      })
    },
    eliminarGrupo(item) {
      this.$swal.fire({
        icon: "info",
        title: "Aviso",
        text: "¿Desea borrar el Grupo del plan?",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then(respuesta => {
        if (respuesta.value) {
          this.$http.put(this.$api + 'planConvenio/grupo/eliminar?idPlan=' + this.idPlan, item).then(respuesta => {
            if (respuesta.data.data) {
              this.grupos.map(value => {
                if (value.idTratamientoGrupo === item.idTratamientoGrupo) {
                  value.seleccionado = false;
                }
              });
              this.gruposSeleccionados.splice(this.gruposSeleccionados.indexOf(item), 1);
            }
          })
        }
      })
      ;

    },
    guardar() {
      this.loaderAcciones = true;
      const parametros = {idPlan: this.idPlan, lista: this.moduloSeleccioonado}
      this.$http.post(this.$api + 'planConvenio/tratamientos/guardar', parametros).then(respuesta => {
        if (respuesta.data.data) {
          this.$swal.fire({
            icon: "success",
            title: "Éxito",
            text: "Los tratamientos se guardaron correctamente",
          });
          this.obtenerTratamientosPorPlan()
          this.moduloSeleccioonado = null;
          this.$v.$reset();
        }
      }).finally(() => {
        this.modalConfiguracion = false;
        this.loaderAcciones = false;
      })
    },
    actualizarTratameinto(dato) {
      const envio = {
        idTratamiento: dato.idTratamiento,
        idTratamientoPlan: dato.idTratamientoPlan,
        nombre: dato.nombre,
        idTipoDescuentoPlan: dato.idTipoDescuentoPlan,
        descuento: dato.descuento,
        descuentoEspecial: dato.descuentoEspecial,
        numeroVeces: dato.numeroVeces,
        idModulo: dato.idModulo
      }
      this.loaderAcciones = true
      this.$http.put(this.$api + 'planConvenio/tratamiento/actualizar', envio).then(respuesta => {
        if (respuesta.data.data) {
          this.$swal.fire({
            icon: "success",
            title: "Éxito",
            text: "El tratamiento se actualizó correctamente",
          });

          this.selecionados.map(mod => {
            if (mod.idModulo === this.tratamientoSelecionado.idModulo) {
              mod.tratamientos.map(tx => {
                if (tx.idTratamiento === this.tratamientoSelecionado.idTratamiento) {
                  tx.idTipoDescuentoPlan = this.configuracionModulo.idTipoDescuentoPlan;
                  tx.descuento = this.configuracionModulo.descuento;
                  tx.descuentoEspecial = this.configuracionModulo.descuentoEspecial;
                  tx.numeroVeces = this.configuracionModulo.numeroVeces;
                  tx.descuentoDefault = this.configuracionModulo.descuentoDefault;
                }
              })
            }
          })

          this.tratamientoSelecionado = null;
          this.$v.$reset();
        }
      }).finally(() => {
        this.modalConfiguracion = false;
        this.loaderAcciones = false;
      })
    },

    guardarGrupoPlan() {
      this.loaderAcciones = true;
      this.grupoSeleccionado.idPlan = this.idPlan;
      this.$http.post(this.$api + 'planConvenio/grupos/guardar', this.grupoSeleccionado)
      .then(respuesta => {
        if (respuesta.data.data) {
          this.$swal.fire({
            icon: "success",
            title: "Éxito",
            text: "Los tratamientos se guardaron correctamente",
          });

          if (this.banderaMod) {
            this.gruposSeleccionados.map(it => {
              if (it.idGrupoPlan === this.grupoSeleccionado.idGrupoPlan) {
                it = this.grupoSeleccionado;
              }
            });
          } else {
            this.obtenerGrupossPorPlan();
          }
          this.grupoSeleccionado = null;
          this.banderaMod = false
          this.obtenerTratamientosPorPlan();
          this.$v.$reset();
        }
      }).finally(() => {
        this.modalConfiguracion = false;
        this.loaderAcciones = false;
      })
    },
    abrirModalNuevoGrupo() {
      this.modalGrupo = true;
      this.nuevoGrupo = {
        nombre: null,
        tratamientos: []
      }
    },
    cambioTabtx(item) {
      this.indexTabTx = item
    },
    editarGrupo(item) {
      this.banderaMod = true;
      this.configuracionModulo = {
        idTipoDescuentoPlan: item.idTipoDescuentoPlan,
        descuento: item.descuento,
        descuentoEspecial: item.descuentoEspecial,
        numeroVeces: item.numeroVeces,
        descuentoDefault: item.descuentoDefault
      };
      this.grupoSeleccionado = item
      this.modalConfiguracion = true;
    },
    detalleGrupo(item) {
      this.detalle = item.tratamientos;
      this.modalDetalleGrupo = true
    },
    eliminarModulo(item) {
      this.$swal.fire({
        icon: "info",
        title: "Aviso",
        text: "¿Desea borrar el modúlo del plan?",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then(respuesta => {
        if (respuesta.value) {

          const lista = [];

          item.tratamientos.map(item => {
            lista.push(item.idTratamientoPlan);
          })

          this.$http.put(this.$api + 'planConvenio/modulo/eliminar', lista).then(respuesta => {
            if (respuesta.data.data) {
              this.modulos.map(value => {
                if (value.idModulo === item.idModulo) {
                  value.seleccionado = false;
                }
              })
              this.selecionados.splice(this.selecionados.indexOf(item), 1);
            }
          })
        }
      })
      ;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.configuracionModulo[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>

</style>
